module.exports = __webpack_public_path__ + "img/email2.92194ba3.png";